import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FormFieldConfig } from "../../models/form-field-config";
import { IFormField } from "../../interfaces/iform-field";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import { FieldError } from "../../models/field-error";
import { FormUtils } from "../../form-utils";

@Component({
    selector: "app-date-picker",
    templateUrl: "./date-picker.component.html",
    styleUrls: ["./date-picker.component.scss"],
})
export class DatePickerComponent implements OnInit, IFormField {
    propertyName: string;
    group: FormGroup;
    config: FormFieldConfig;
    errors = new Array<FieldError>();
    isVisible = true;
    inline = false;

    constructor() {}

    ngOnInit() {
        if (this.config) {
            this.propertyName = this.config.fieldInfo.name;
            this.inline = this.config.fieldInfo.inline;
        }
    }

    setObservableDataSource(data: any) {}

    getErrorList() {
        const control = this.group.controls[this.config.fieldInfo.name];
        this.errors.length = 0;

        if (control.errors) {
            this.errors = FormUtils.getErrorRepresentation(control.errors);
        }

        return this.errors;
    }

    onFocus(event) {
        if (this.errors) {
            this.errors.length = 0;
        }
    }

    onLostFocus(event) {
        this.getErrorList();
    }

    setVisible(isVisible: boolean) {
        this.isVisible = isVisible;
    }

    isControlVisible(): boolean {
        return this.isVisible;
    }
}
